import type { SelectionExtensionPluginOptions } from '@atlaskit/editor-plugin-selection-extension';

import { useJiraWorkCreateSelectionExtension } from '@confluence/jira-work-create-extension';
import { fg } from '@confluence/feature-gating';
import type { PageMode } from '@confluence/issue-create-side-panel';

export const useSelectionExtensionPluginOptions = ({
	isSidePanelOpenRef,
	pageModeRef,
}: {
	isSidePanelOpenRef: React.MutableRefObject<boolean>;
	pageModeRef: React.MutableRefObject<PageMode>;
}): SelectionExtensionPluginOptions => {
	const jiraWorkCreateSelectionExtension = useJiraWorkCreateSelectionExtension({
		isSidePanelOpenRef,
		pageModeRef,
	});

	return {
		extensions: fg('confluence_work_create_edit_and_live_docs_support')
			? { firstParty: [jiraWorkCreateSelectionExtension] }
			: {},
	};
};
